import React                     from "react";
import PropTypes                 from "prop-types";
import Flux                      from "../../flux/Flux";
import ProfileOverviewVideosGrid from "./ProfileOverviewVideosGrid";

export const GridTypes   = {
	NEWEST:       'NEWEST',
	BEST_SELLING: 'BEST_SELLING',
	CLASSIC:      'CLASSIC',
};
export const VIDEO_COUNT = 4;

const VIDEO_SORT_ORDERS            = Flux.Constants.Vxql.Videos.SortOrders;
const GRID_TYPE_SORT_ORDER_MAPPING = {
	[GridTypes.NEWEST]:       VIDEO_SORT_ORDERS.NEWEST,
	[GridTypes.BEST_SELLING]: VIDEO_SORT_ORDERS.BEST_SELLING,
	[GridTypes.CLASSIC]:      VIDEO_SORT_ORDERS.NEWEST,
};

class ProfileOverviewVideos extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	getFilter() {
		const filter = {modelIds: [this.props.actorId]};
		if (this.props.type === GridTypes.CLASSIC) {
			filter['types'] = [{classic: true}];
		}

		return filter;
	}

	getOrder() {
		return GRID_TYPE_SORT_ORDER_MAPPING[this.props.type];
	}

	render() {
		return <ProfileOverviewVideosGrid 
					actorId		      = {this.props.actorId}
					actorName		  = {this.props.actorName}
					count			  = {VIDEO_COUNT}
					filter		      = {this.getFilter()}
					headlineType	  = {this.props.headlineType}
					lazyImageLoading  = {this.props.lazyImageLoading}
					navigateTo		  = {this.props.navigateTo}
					order			  = {this.getOrder()}
		/>;
	}
}

ProfileOverviewVideos.propTypes = {
	actorId:           PropTypes.number.isRequired,
	actorName:         PropTypes.string.isRequired,
	type:              PropTypes.oneOf(Object.values(GridTypes)),
	lazyImageLoading:  PropTypes.bool,
	headlineType:      PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	navigateTo:		   PropTypes.func,
};

ProfileOverviewVideos.defaultProps = {
	type:             GridTypes.NEWEST,
	lazyImageLoading: false,
	headlineType:     Flux.Constants.Headlines.h4,
};

export default ProfileOverviewVideos;
